var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"when-visible",rawName:"v-when-visible",value:(_vm.loadImage),expression:"loadImage"}],staticClass:"vz-lazy-image",style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }